export default "<div class=\"page\">\n\n  <h2>Admin Dashboard</h2>\n\n  <specapp-admin-component></specapp-admin-component>\n</div>\n";